// Canonical enrichment for hack-post rows.
// The API returns details as [{ setting_name, value, ... }].
export function enrichPostRow(row) {
  const details = row.details || []
  const find = name => details.find(d => d.setting_name === name)?.value || ''
  const country_code = find('country_code') || row.country_code || ''
  return {
    ...row,
    country_code,
    country:    country_code,
    domain:     find('domain')     || row.domain     || '',
    activity:   find('activity')   || row.activity   || '',
    attackdate: find('attackdate') || row.attackdate || '',
  }
}
